<template>
  <vue-final-modal
    :value="value"
    :name="name"
    :classes="['new-rirekisho-reset-dialog__container']"
    :content-class="[
      'new-rirekisho-reset-dialog__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="$emit('input', $event)"
    @opened="onOpened"
  >
    <div class="v--modal-close-top">
      <el-button
        icon="el-icon-close"
        type="text"
        @click="$emit('input', false)"
      />
    </div>
    <div class="title">{{ title }}</div>
    <span>{{ message }}</span>
    <div :class="actionsClass">
      <el-button type="primary" @click="onConfirm">リセットする</el-button>
      <el-button @click="$emit('input', false)">リセットしない</el-button>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'

defineProps<{
  value: boolean
  name: string
  title: string
  message: string
  actionsClass?: string
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'confirm'): void
}>()

function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.new-rirekisho-reset-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onConfirm() {
  emit('input', false)
  emit('confirm')
}
</script>

<!--
  旧 vue-js-modal: adaptive + scrollable + height="auto"（width 未指定 = 600px）。
  Pattern A: :styles flex 禁止。配置・スクロールは __container。
  attach=body 時の absolute を fixed 化（ページ縦スクロール位置に依存しない）。
-->
<style lang="scss">
@import '@/assets/scss/format-edit/vfm-attach-body-fixed';
@include vfm-root-fixed-when-has('.new-rirekisho-reset-dialog__container');

.new-rirekisho-reset-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.new-rirekisho-reset-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 1 auto;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 20px 20px 50px;
  left: 0 !important;
}

.new-rirekisho-reset-dialog__content .title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.75rem;
}

.new-rirekisho-reset-dialog__content .v--modal-close-top {
  text-align: right;
}
</style>
